import { Image, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { pdfStyles } from '../pdfStyles';
import { logo } from '../imgData';
import { ColorSet } from 'src/redux/reducers/theme';

interface HeaderCompanyProps {
  companyName: string;
  title: string;
  companyImage?: string;
  label?: string;
  colors: ColorSet;
}

export const HeaderCompany: React.FC<HeaderCompanyProps> = ({ label, companyName, title, companyImage, colors }) => {
  return (
    <>
      <View style={{ backgroundColor: colors.cultured }}>
        <View style={{ ...pdfStyles.section, paddingTop: 30, paddingBottom: 30 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Image src={logo} style={{ width: 120, height: 43, left: 0 }} />
            <View style={{ width: 123 }}>
              <Text style={{ fontSize: 10, fontWeight: 600, color: colors.prussianBlue }}>{companyName}</Text>
            </View>
          </View>
          <View style={{ ...pdfStyles.spacer32 }} />
          <View style={{ ...pdfStyles.spacer32 }} />
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <View>
              {label && <Text style={pdfStyles.label}>{label}</Text>}
              <Text style={{ color: colors.prussianBlue, fontWeight: 600, fontSize: 22 }}>{title}</Text>
            </View>
            {companyImage && (
              <View style={{ width: 120, marginRight: 5 }}>
                <View
                  style={{
                    width: 120,
                    height: 140,
                    backgroundColor: colors.white,
                    top: 0,
                    position: 'absolute',
                    padding: 10,
                  }}
                >
                  <View
                    style={{
                      border: `0.7px solid ${colors.gp1}`,
                      flex: 1,
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Image src={companyImage} style={{ width: '100%' }} />
                  </View>
                </View>
              </View>
            )}
          </View>
        </View>
      </View>
      <View style={{ ...pdfStyles.spacer32 }} />
    </>
  );
};
